// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PiiRule
 */
export interface PiiRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof PiiRule
     */
    columns?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PiiRule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the PiiRule interface.
 */
export function instanceOfPiiRule(value: object): value is PiiRule {
    return true;
}

export function PiiRuleFromJSON(json: any): PiiRule {
    return PiiRuleFromJSONTyped(json, false);
}

export function PiiRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PiiRule {
    if (json == null) {
        return json;
    }
    return {
        
        'columns': json['columns'] == null ? undefined : json['columns'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function PiiRuleToJSON(json: any): PiiRule {
    return PiiRuleToJSONTyped(json, false);
}

export function PiiRuleToJSONTyped(value?: PiiRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'columns': value['columns'],
        'enabled': value['enabled'],
    };
}
